import './OrderDetails.css';
import OrderDetailsProducts from './sub/OrderDetailsProducts/OrderDetailsProducts.jsx';
import {useEffect, useState} from "react";
import {fetchUserOrderDetails} from "../../../../../../CustomerHandler.js";

export default function OrderDetails({orderID}) {
    const [order,setOrder] = useState(null);


    useEffect(() => {
        const token = sessionStorage.getItem("customerAccessToken");

       const fetchData = async () => {
           const data = await fetchUserOrderDetails(orderID,token);
           setOrder(data)
       }

       fetchData()
    },[])


    return (order !== null ? <><div className="order-details">
            <div className="order-details-header">
                <div className="order-details-id">
                    Zamówienie nr <b>{order.id}</b>
                </div>
                <div className="order-details-date">
                    Złożone {order.date}
                </div>
            </div>

            {/*<Section label="Płatność">*/}
            {/*    <div className="order-details-box">*/}
            {/*        <div*/}
            {/*            className="order-details-icon"*/}
            {/*            style={{ backgroundImage: 'url(/images/placeholder-image.webp)' }}*/}
            {/*        />*/}
            {/*        <span>{order.paymentMethod}</span>*/}
            {/*    </div>*/}
            {/*</Section>*/}
        {order.shippingAddress!==null &&  <Section label="Dane do wysyłki">
            <div className="order-details-box" id='order-details-shipping-box'>
                <span><b>{order.shippingAddress.name}</b></span>
                <span>{order.shippingAddress.address}</span>
                <span>{order.shippingAddress.postal} {order.shippingAddress.city}</span>
                <span>{order.shippingAddress.country}</span>
                <span>{order.shippingAddress.phoneNumber}</span>
            </div>
        </Section>}
            <Section label="Dane do faktury">
                <div className="order-details-box" id='order-details-invoice-box'>
                    <span><b>{order.invoiceData.name}</b></span>
                    {order.invoiceData.nip && <span>{order.invoiceData.nip}</span>}
                    <span>{order.invoiceData.address}</span>
                    <span>{order.invoiceData.postal}{order.invoiceData.city}</span>
                    <span>{order.invoiceData.country}</span>
                    <span>{order.invoiceData.phoneNumber}</span>
                </div>
            </Section>


            <OrderDetailsProducts items={order.items} deliveryPrice={order.deliveryPrice} />
        </div></> : <></>)

}

function Section({ label, children }) {
    return (
        <div className="order-details-section">
            <span className="order-details-section-label">{label}</span>
            {children}
        </div>
    );
}
